import React from 'react';
import Link from 'next/link';

import { Button } from '@tmap/mmm-style-guide/src/Button';
import { ArrowForward, Inbox, PersonSearch, CardGiftcard, HomeIcon } from '@tmap/mmm-style-guide/src/Icon';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';

function ApprovalProcessBlock(props) {
  const { pageSettings } = props;
  return (

    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant='h4' fontWeight={600}>{pageSettings.approvalProcessLead}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1' color='textSecondary' sx={{ marginBottom: 1, maxWidth: { md: '50%' } }}>{pageSettings.approvalProcessSubLead}</Typography>
      </Grid>
      {pageSettings.approvalProcessSteps.map((block, i) => (
        <Grid item xs={12} lg={6} key={`hiw-row-${i}`}>
          <Grid container spacing={{ xs: 1, sm: 2 }}>
            <Grid item>{[
              <Inbox color='secondary' fontSize='large' />,
              <PersonSearch color='secondary' fontSize='large' />,
              <CardGiftcard color='secondary' fontSize='large' />,
              <HomeIcon color='secondary' fontSize='large' />,
            ][i]}
            </Grid>
            <Grid item xs={12} sm>
              <Grid container spacing={1}>
                <Grid item xs={12}><Typography variant='h6' fontWeight={600}>{block.leadCopy}</Typography></Grid>
                <Grid item xs={12}><Typography variant='body1' color='textSecondary'>{block.subLeadCopy}</Typography></Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}
      {(pageSettings.approvalProcessInfoLink && pageSettings.approvalProcessInfoText) && (
        <Grid item xs={12}>
          <Link href={pageSettings.approvalProcessInfoLink}>
            <Button variant='outlined' color='inverted' size='large' endIcon={<ArrowForward />}>{pageSettings.approvalProcessInfoText}</Button>
          </Link>
        </Grid>
      )}
    </Grid>
  );
}

export default ApprovalProcessBlock;
